import { _get, _put } from "../../../../http";

// porcentaje de ganancia distribución
export const getPorcentajeDeGananciaDistribucion = (distribucionId) =>
  _get(`/distribuciones/${distribucionId}/porcentajeDeGanancia`);

export const putPorcentajeDeGananciaDistribucion = (distribucionId, body) =>
  _put(`/distribuciones/${distribucionId}/porcentajeDeGanancia`, body);
